import * as React from 'react';
import SideBar from './side-bar';

const SideBarContainer: React.FunctionComponent = (): JSX.Element => {
  return (
    <div>
      <SideBar />
    </div>
  );
};
export default SideBarContainer;
